'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = withSingleSignOn;

var _reactHyperscript = require('react-hyperscript');

var _reactHyperscript2 = _interopRequireDefault(_reactHyperscript);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _sso = require('../../integrations/sso');

var _config = require('../../utils/config');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var handleSSO = function handleSSO(e, config) {
  e.preventDefault();
  var ssoURL = (0, _sso.getSingleSignOnURL)(config);

  if (!_lodash2.default.isEmpty(ssoURL)) {
    var urlParams = {
      componentId: config.componentId,
      origin: window.location.href
    };
    var relayStateString = encodeURIComponent(JSON.stringify(urlParams));
    window.location.assign(ssoURL + '?RelayState=' + relayStateString);
  }
};

var setSignOnHandler = function setSignOnHandler(config) {
  return (0, _config.attachHandlerToButtonClick)(config, 'handleSSO', function (e) {
    return handleSSO(e, config);
  });
};

function withSingleSignOn(wrappedComponent) {
  return function (props) {
    return (0, _reactHyperscript2.default)(wrappedComponent, _extends({}, props, {
      config: setSignOnHandler(props.config)
    }));
  };
}